export default __webpack_public_path__ + "static/staffy-new-logo-f84a51d980151ec92969a6ec29131f3e.webp";